// MarketsPage.js
import React, { useEffect } from "react";
import "./MarketsPage.css";
import MarketsGate from "../../../MarketsGate";

export default function MarketsPage() {
    useEffect(() => {
        document.body.classList.add("page-markets");
        return () => document.body.classList.remove("page-markets");
    }, []);

    return (
        <div className="markets-page">
            <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "100%" }}>
                <MarketsGate
                    token={localStorage.getItem("access_token")}
                    height="100%"
                    mountId="salesplay-chatbot-markets"
                />
            </div>
        </div>
    );
}
